import { type FC, useState, useCallback } from 'react';
import { trackNewSellerPillHover } from '../../tracking/newSellerPillTracking';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { Badge, type BackgroundColor } from 'dibs-elements/exports/Badge';
import { Tooltip } from 'dibs-elements/exports/Tooltip';

// styles
import styles from './PdpSharedNewSellerPill.scss';

export const PdpSharedNewSellerPill: FC<{
    backgroundColor?: BackgroundColor;
    unsetTextSize?: boolean;
}> = ({ backgroundColor, unsetTextSize = false }) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);
    const showTooltip = useCallback(() => {
        setIsTooltipOpen(true);
        trackNewSellerPillHover();
    }, []);
    const hideTooltip = useCallback(() => setIsTooltipOpen(false), []);

    return (
        <span
            className={styles.container}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            data-tn="pdp-new-seller-pill"
        >
            <Badge backgroundColor={backgroundColor} type="pill" size="small-heavy">
                <span className={unsetTextSize ? undefined : styles.text}>
                    <FormattedMessage
                        id="PdpSharedNewSellerPill.pill_text"
                        defaultMessage="New to 1stDibs"
                    />
                </span>
            </Badge>

            <Tooltip isVisible={isTooltipOpen} direction="top" type="small">
                <div className={styles.tooltipText}>
                    <FormattedMessage
                        id="PdpSharedNewSellerPill.tooltip"
                        defaultMessage="Joined in the past six months."
                    />
                </div>
            </Tooltip>
        </span>
    );
};
